import { IconButton, Tooltip, Typography } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import React from 'react';
import { filterTypes } from '../../../utils/filter-utils';
import { formatNumber } from '../../../utils/form-utils';

const AccionesMercaderia = ({ item, classes, onEdit, onDelete }) => {
  return (
    <TableCell className={classes.tableCellAction}>
      {onEdit && (
        <Tooltip title="Editar" aria-label="editar">
          <IconButton aria-label="editar" onClick={() => onEdit(item)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title="Eliminar" aria-label="eliminar">
          <IconButton aria-label="delete" onClick={() => onDelete(item)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
};

const mercaderiasConfig = props => {
  const { classes, enqueueSnackbar, onEdit, onDelete } = props;
  return {
    mercaderias: {
      datosConfig: {
        titulo: 'Mercaderías cargadas',
        servicio: 'formulario/mercaderias',
        url: 'mercaderias'
      },
      datosSettings: {
        serie: {
          label: 'Serie',
          type: filterTypes.STRING,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.index}</TableCell>
          )
        },
        partidaArancelaria: {
          label: 'Partida Arancelaria',
          type: filterTypes.STRING,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.partidaArancelaria.codigo || ''}
            </TableCell>
          )
        },
        descripcion: {
          label: 'Descripción',
          type: filterTypes.STRING,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.descripcion}
            </TableCell>
          )
        },
        cantidad: {
          label: 'Cantidad/UTF',
          type: filterTypes.NUMERIC,
          cellRendering: item => (
            <TableCell className={classes.tableCell} align="right">
              <Typography variant="body2" noWrap>
                {item.cantidad}
              </Typography>
            </TableCell>
          )
        },
        unidad: {
          label: 'Unidad M.',
          type: filterTypes.STRING,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              <Typography variant="body2" noWrap>
                {item.unidad?.descripcion || ''}
              </Typography>
            </TableCell>
          )
        },
        valorVenta: {
          label: 'Valor de venta',
          type: filterTypes.NUMERIC,
          cellRendering: item => (
            <TableCell className={classes.tableCell} align="right">
              <Typography variant="body2" noWrap>
                {formatNumber(item.valorVenta)}
              </Typography>
            </TableCell>
          )
        },
        peso: {
          label: 'Peso (Kg.)',
          type: filterTypes.NUMERIC,
          cellRendering: item => (
            <TableCell className={classes.tableCell} align="right">
              <Typography variant="body2" noWrap>
                {formatNumber(item.peso)}
              </Typography>
            </TableCell>
          )
        },
        numero: {
          label: 'Nro. de factura',
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              <Typography variant="body2" noWrap>
                {item.factura?.nroFactura}
              </Typography>
            </TableCell>
          )
        },
        fecha: {
          label: 'Fecha de factura',
          type: 'date',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.factura
                ? moment(item.factura.fechaFactura).format('DD/MM/YYYY')
                : '-'}
            </TableCell>
          )
        },
        ...(onEdit || onDelete
          ? {
              actions: {
                label: 'Acciones',
                sortable: false,
                cellRendering: item => (
                  <AccionesMercaderia
                    item={item}
                    classes={classes}
                    enqueueSnackbar={enqueueSnackbar}
                    onEdit={onEdit}
                    onDelete={onDelete}
                  />
                )
              }
            }
          : {})
      }
    }
  };
};

export default mercaderiasConfig;
